// src/components/layout/mobile/MobileCreateSheet.tsx
import { useNavigate } from 'react-router-dom';
import { CheckSquare, Ticket, MessageSquare, FolderKanban } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui';

interface MobileCreateSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const createOptions = [
  {
    icon: CheckSquare,
    label: 'Nueva Actividad',
    description: 'Tarea, reunión o seguimiento',
    path: '/actividades',
  },
  {
    icon: Ticket,
    label: 'Nuevo Ticket',
    description: 'Solicitud de soporte formal',
    path: '/tickets',
  },
  {
    icon: MessageSquare,
    label: 'Nueva Conversación',
    description: 'Chat con cliente o equipo',
    path: '/conversaciones',
  },
  {
    icon: FolderKanban,
    label: 'Nuevo Proyecto',
    description: 'Proyecto con fases y sprints',
    path: '/proyectos',
  },
];

export function MobileCreateSheet({ open, onOpenChange }: MobileCreateSheetProps) {
  const navigate = useNavigate();

  const handleSelect = (option: typeof createOptions[number]) => {
    onOpenChange(false);
    navigate(option.path);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      {/* side="left" used as base — CSS overrides position it as bottom sheet
          (Radix Sheet doesn't support side="bottom") */}
      <SheetContent side="left" className="w-full max-w-full inset-x-0 bottom-0 top-auto h-auto rounded-t-xl p-0 border-t">
        <SheetHeader className="px-4 pt-4 pb-2">
          <SheetTitle className="text-base">Crear nuevo</SheetTitle>
          <SheetDescription className="sr-only">Selecciona qué deseas crear</SheetDescription>
        </SheetHeader>
        <div className="px-2 pb-4 safe-area-bottom">
          {createOptions.map((option) => {
            const Icon = option.icon;
            return (
              <button
                key={option.label}
                onClick={() => handleSelect(option)}
                className="w-full flex items-center gap-3 px-3 py-3 rounded-lg active:bg-muted/50 transition-colors text-left"
              >
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 text-primary">
                  <Icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="text-sm font-medium">{option.label}</div>
                  <div className="text-xs text-muted-foreground">{option.description}</div>
                </div>
              </button>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
